export { renderSelect_unstable as renderSelect } from '@fluentui/react-select';
